export enum RoleTypeEnum {
  ADMIN = "ADMIN",
  USER = "USER",
}
